module.exports = __webpack_public_path__ + "static/media/fms222.161f7d14.jpg";